import { render, staticRenderFns } from "./student.vue?vue&type=template&id=394c9b66&scoped=true"
import script from "./student.vue?vue&type=script&lang=js"
export * from "./student.vue?vue&type=script&lang=js"
import style0 from "./student.vue?vue&type=style&index=0&id=394c9b66&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394c9b66",
  null
  
)

export default component.exports